module.exports = __webpack_public_path__ + "media/images/berryvirtual-89e9077a9d3a21348295c9eec3ff1c31.png";